import { render, staticRenderFns } from "./valmistumispyynnot-vastuuhenkilo-erikoistuva-laakari.vue?vue&type=template&id=516cbfcb&"
import script from "./valmistumispyynnot-vastuuhenkilo-erikoistuva-laakari.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-vastuuhenkilo-erikoistuva-laakari.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports